import Tooltip from '~components/common/Tooltip';
import ExclamationMark from '~components/Icon/ExclamationMark';
import Text from '~components/Text';
import { numberToKorean, salesDisplayPercent } from '~hooks/query/company/useCompanySales';
import theme from '~lib/styles/Theme';
import { Sales } from '~types/company';
import * as S from '../style';

interface Props {
  title: string;
  sales: Sales;
  tooltipText?: string;
  type: 'total' | 'salary' | 'person';
}

function SalesRate({ title, sales, tooltipText, type }: Props) {
  return (
    <S.SalesInfoCard>
      <S.Row>
        <Text typography='midium120_B3'>{title}</Text>
        {tooltipText && (
          <Tooltip
            tooltipText={tooltipText}
            position='center'
            width={type === 'person' ? 120 : 190}>
            <ExclamationMark width={15} color={theme.colors.gray700} />
          </Tooltip>
        )}
      </S.Row>
      <hr />
      <S.Row>
        <Text typography='bold120_T1'>
          {sales.sales ? numberToKorean(sales.sales, type) : '정보없음'}
        </Text>
      </S.Row>
      <S.Row>
        <Text typography='midium150_C1'>
          <span className='grayColor'>{sales.rateType === 'INDUSTRY' ? '동종업계' : '전체'}</span>
          <strong className='emphasize'>{` 상위 ${salesDisplayPercent(sales, type)}%`}</strong>
        </Text>
      </S.Row>
    </S.SalesInfoCard>
  );
}

export default SalesRate;
